export default __webpack_public_path__ + "static/logo-02b5591f21984f2b8d5bb234c47357c3.svg";